module.exports = __webpack_public_path__ + "media/pl_pl_s1_Antek.48f50923.mp3";